'use client';

import { motion } from 'framer-motion';

export default function BioeconomyComponent() {
  return (
    <motion.div
      className='bg-secondary py-10 text-center'
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}>
      <motion.h2
        className='text-brand-dark dark:text-brand-dark-text-primary mb-4 text-2xl font-bold'
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5, delay: 0.2 }}>
        Discover Bioeconomy's potential with us.
      </motion.h2>
      <motion.button
        className='rounded-full border-4 border-lime-600 bg-purple-700 px-4 py-2 text-lg font-bold text-white shadow-md transition duration-300 ease-in-out hover:bg-lime-600 md:text-xl dark:border-lime-600 dark:bg-purple-600 dark:hover:bg-teal-200'
        whileHover={{ scale: 1.05, rotate: 3, transition: { duration: 0.3 } }}
        whileTap={{ scale: 0.95 }}>
        SUBSCRIBE
      </motion.button>
    </motion.div>
  );
}
